import { render, staticRenderFns } from "./CartaoVirtualImpressao.vue?vue&type=template&id=4056da84&scoped=true"
import script from "./CartaoVirtualImpressao.vue?vue&type=script&lang=js"
export * from "./CartaoVirtualImpressao.vue?vue&type=script&lang=js"
import style0 from "./CartaoVirtualImpressao.vue?vue&type=style&index=0&id=4056da84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4056da84",
  null
  
)

export default component.exports